import { LocalStorageDataModel } from "@Constants/local-storage-data-model";
import { Env, getDataFromLocalStorage } from "@Src/utils/globalUtilities";
import axios from "axios";

const unauthorizedCode = [401];
const bypassErrorToComponentCode = ["FAILURE"];
const generateMachineId = () => {
  return Math.random().toString(36).slice(2, 15);
};

export const BookStoreBaseService = axios.create({
  timeout: 60000,
  baseURL: Env().REACT_APP_NODE_BOOKSTORE_BASE_URL,
});

BookStoreBaseService.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem(LocalStorageDataModel.AUTH_TOKEN);
    let machineid = localStorage.getItem(LocalStorageDataModel.MACHINE_ID_NEW);

    let contenttoken = localStorage.getItem(
      LocalStorageDataModel.CONTENT_TOKEN
    );

    config.headers = {
      refreshtoken: sessionStorage.getItem("refreshToken") || "",
      machineid: machineid,
    };

    if (token) {
      config.headers = {
        ...config.headers,
        taxmannauthorization: token,
        contenttoken: contenttoken,
      };
    }
    return config;
    // config.headers = {
    //     		'authorization ': 'eyJhbGciOiJIUzI1NiJ9.eyJpZCI6IjMiLCJlbWFpbCI6IjMiLCJ0aW1lU3RhbXAiOjE2ODE5MTE0MjI0MjQsIm5iZiI6MTY4MTkxMTQyMiwiZXhwIjoxNjg0NTAzNDIyLCJpYXQiOjE2ODE5MTE0MjIsImlzcyI6Ijg3M2IxYWRkLTcwMzQtNDYyNy04NzgzLTA1M2Q0N2JiODE0OCIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6NjQwNjQvIn0.G2sMfBodWz4-QSm2Ps5Gavms84MvGh4JRoDWxCJ6A1I'
    //     	}
    // return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

BookStoreBaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (bypassErrorToComponentCode.includes(response.data?.ResponseType)) {
      return response;
    }
    if (response && unauthorizedCode.includes(response.status)) {
    }
    return Promise.reject(error);
  }
);
